import {GemSettings} from '../config/interface';

export function loadScriptsToDOM(gemSettings: GemSettings) {
    const scriptsFeatureSettingConfig = gemSettings.features.find((feature) => feature?.featureName === 'scripts');
    if (!scriptsFeatureSettingConfig?.scripts || scriptsFeatureSettingConfig.scripts.length === 0) {
        return;
    }

    scriptsFeatureSettingConfig.scripts.forEach((scriptSettingConfig) => addScriptToDOM(scriptSettingConfig.path, scriptSettingConfig.delay));
}

function addScriptToDOM(path: string, delay?: number) {
    const scriptElement = document.createElement('script');
    scriptElement.src = path;

    setTimeout(() => {
        document.head.appendChild(scriptElement);
    }, delay || 5000);
}
